module.exports = __webpack_public_path__ + "img/market-place-fullGrey.f488060d.svg";